import type { ProductChoicesListType } from '@virginexperiencedays/products/src/types';

import { Container } from '../../../layout/Container';

import { ProductChoicesHeader } from './ProductChoicesHeader';
import { ProductChoicesGrid } from './ProductChoicesGrid';

type ProductChoicesProps = {
  numProductChoices: number;
  productChoicesList: ProductChoicesListType[];
  baseURL: string;
  onClick?: (data: { title: string }) => void;
};

export const ProductChoices = ({
  numProductChoices,
  productChoicesList = [],
  baseURL,
  onClick,
}: ProductChoicesProps) => {
  if (!Array.isArray(productChoicesList) || !productChoicesList.length) return null;

  return (
    <section className="bg-background-primary-faded my-20 py-10">
      <Container>
        <ProductChoicesHeader numProductChoices={numProductChoices} />
        <ProductChoicesGrid
          productChoicesList={productChoicesList}
          baseURL={baseURL}
          onClick={onClick}
        />
      </Container>
    </section>
  );
};
